import { render, staticRenderFns } from "./ClosedTests.vue?vue&type=template&id=fb043faa&"
import script from "./ClosedTests.vue?vue&type=script&lang=js&"
export * from "./ClosedTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports